module.exports = __webpack_public_path__ + "static/media/supply_icon.77924991.png";